<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
            </ul>
        </div>    
        <div class="mainindex">
            <div class="welinfo">
                <span><img src="../assets/images/sun.png" alt="天气" /></span>
                <b>{{account}}&nbsp;&nbsp;{{time}}，欢迎使用云办公开放平台</b>
                <a href="/personinfo">帐号设置</a>
            </div>
    
            <div class="welinfo">
                <span><img src="../assets/images/time.png" alt="时间" /></span>
                <i>您上次登录的时间：{{lastLoginTime}}</i>
                <template v-if="userCouponList != null && userCouponList.length>0"><i class="f18">您有<a style="font-size: 24px;color: #c70931;cursor: pointer;" href="#" @click="goUserCoupon">{{userCouponList.length}}</a> 张充值抵用券即将到期！请尽快<a style="font-size: 36px; color: #EE680E" href="#" @click="goCharge">去充值</a>！</i> </template>
                                
            </div> 
              
            <div class="ku_1l" >
                <div class="fl_le jiang">
                    推荐<strong class="f24 f00">奖"100元"</strong>等你来拿！！！<br/>
                        ❤-感恩回馈，推荐有礼-❤  <br/>
                    活动期内<strong class="f18 f00">推荐用户成功办理一个400电话</strong><br/>
                    ~ 即可拿到百元大奖 ~<br/>
                    多推荐多得哦！！！！
                </div>               

                
                <div class="fl_le ha" >
                    <h1 class="h_a">最新推荐成功名单</h1>
                    <div id="xst" style="width:250px;height:180px; color:#c70931;">
                        <p>
                            23***18获得10元奖励<br/>
                            31***34获得100元奖励<br/>
                            25***78获得50元奖励<br/>
                            21***37获得100元奖励<br/>
                            57***12获得50元奖励<br/>
                            31***42获得100元奖励<br/>
                            21***11获得100元奖励<br/>
                            27***91获得50元奖励<br/>
                            91***66获得50元奖励<br/>
                            45***53获得100元奖励<br/>
                            66***13获得50元奖励<br/>
                            54***02获得100元奖励<br/>
                            12***12获得100元奖励<br/>
                            25***18获得100元奖励<br/>
                        </p>
                    </div>
                </div>                  
            </div>
            <div class="xline"></div>
            <div class="box"></div> 
    
            <div class="welinfo">
                <span><img src="../assets/images/dp.png" alt="提醒" /></span>
                <b>系统公告</b>
            </div>
    
            <ul class="infolist">
                <li><span style="font-size:18px;color:#EE680E;">（1）400电话办理360元起，咨询办理请联系旺旺：<a target="_blank" href="//amos1.taobao.com/msg.ww?v=2&uid=第二办公室&s=1"><img src="../assets/images/T1uUG.XjtkXXcb2gzo-77-19.gif" width="77" height="19" /></a>!门槛低、资费低、办理快，8年品质保证，赶快行动吧！</span></li>
                <li><span style="font-size:18px;color:#EE680E;">（2）商标注册499元起，咨询注册请联系旺旺：<a target="_blank" href="//amos1.taobao.com/msg.ww?v=2&uid=secondoffice&s=1"><img src="../assets/images/T1uUG.XjtkXXcb2gzo-77-19.gif" width="77" height="19" /></a>活动期内推荐用户注册一个商标，奖"50元"等你来拿！！！</span></li>
                <li><span>（3）第二办公室推出快速专业的短信、电话、手机注册验证服务,请加旺旺2office：<a target="_blank" href="//amos1.taobao.com/msg.ww?v=2&uid=2office&s=1"><img src="../assets/images/T1uUG.XjtkXXcb2gzo-77-19.gif" width="77" height="19" /></a></span></li>
            </ul>
    
            <div class="xline"></div>
            <div class="box"></div>
    
            <div class="welinfo">
                <span><img src="../assets/images/dp.png" alt="提醒" /></span>
                <b>留言板</b>
            </div>
    
            <ul class="infolist_plb">
                <li class="f0f2f3 pa20"><span></span></li>
                <!-- <li class="f0f2f3 pa20 mt20"><span></span></li>             -->
            </ul>    
    
            <div class="xline"></div>
            <div class="box"></div>
    
            <div class="welinfo">
                <span><img src="../assets/images/dp.png" alt="提醒" /></span>
                <b>日程提醒</b>
            </div>    
            <ul class="infolist_plb">
                <li>  
                    <table class="tablelist">
    	                <thead>
                            <tr>
                                <th>序号</th>
                                <th>时间</th>
                                <th>事件</th>
                                </tr>
                            </thead>
                        <tbody>
                            <tr v-for="(item,index) in tiXingList">
                                <td>{{index+1}}</td>
                                <td>{{item.nexttime}}</td>
                                <td>{{item.txtitle}}</td>
                            </tr>
                        </tbody>
                    </table>
    
                </li>
            </ul>    
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
var scrollingBox;
var scrollingInterval;
var reachedBottom = false;
var bottom;
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            lastLoginTime:'',
            tiXingList:[],
            account:'',
            time:'',
            userCouponList:[]
        }
    },
    mounted(){
        this.getData();
        let hours = new Date().getHours();
        if( hours >= 0 && hours < 6 ){
            this.time = '凌晨好';
        }else if( hours>= 6 && hours < 9 ){
            this.time = '早上好';
        }else if( hours >= 9 && hours < 12 ){
            this.time = '上午好';
        }else if( hours == 12 ){
            this.time = '中午好';
        }else if ( hours > 12 && hours < 18 ){
            this.time = '下午好';
        }else if( hours >= 18 && hours <22 ){
            this.time = '晚上好';
        }else{
            this.time = '深夜好';
        }
        
    },
    created(){
        this.addEventSimple(window, 'load', this.initScrolling);
    },
    methods:{
        getData(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/main/desktopinfo.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(JSON.stringify(res.data));
                if('0000000' == res.data.code)
                {
                    that.lastLoginTime = res.data.lastLoginTime;
                    that.tiXingList = res.data.tiXingList;
                    that.account = res.data.account;
                    that.userCouponList = res.data.userCouponList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addEventSimple(obj, evt, fn) {
            if (obj.addEventListener) {
                obj.addEventListener(evt, fn, false);
            } else if (obj.attachEvent) {
                obj.attachEvent('on' + evt, fn);
            }
        },
        initScrolling() {
            scrollingBox = document.getElementById('xst');
            scrollingBox.style.overflow = "hidden";
            scrollingInterval = setInterval(this.scrolling, 100);
            scrollingBox.onmouseover = this.over;
            scrollingBox.onmouseout = this.out;
        },
        scrolling() {
            var origin = scrollingBox.scrollTop++;
            if (origin == scrollingBox.scrollTop) {
                if (!reachedBottom) {
                    scrollingBox.innerHTML += scrollingBox.innerHTML;
                    reachedBottom = true;
                    bottom = origin;
                } else {
                    scrollingBox.scrollTop = bottom;
                }
            }
        },
        over() {
            clearInterval(scrollingInterval);
        },
        out() {
            scrollingInterval = setInterval(this.scrolling, 100);
        },
        goCharge(){
            location.href = "chargeaccount";
        },
        goUserCoupon(){
            location.href = "usercoupon";
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/desktop.vue